import { render } from "./History.vue?vue&type=template&id=5793186c"
import script from "./History.vue?vue&type=script&lang=ts"
export * from "./History.vue?vue&type=script&lang=ts"

import "./History.vue?vue&type=style&index=0&id=5793186c&lang=scss"
script.render = render

export default script